import React from 'react';
const Footer = () =>{
  return (
    <footer>
      <div className="container">
        <div className="footer-tagline">
          <p>With purity & trust From Farmers to you</p>
        </div>
        <div className="footer-links">
          <a href="mailto:info@dhapufarms.com">info@dhapufarms.com</a> | <a href="tel:+917477239550">+91 74772 39550</a>
        </div>
        <p>© 2024 Dhapu Farms. All Rights Reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;